import nolimit from './nolimit.js';

const providers = {
	nolimitcity: nolimit
};

function load(providerAndParameters, errMsg, gameMode, target, props, previousLocation, basePathname) {
	return providers[providerAndParameters.provider].load({
		params: providerAndParameters.parameters,
		errMsg,
		gameMode,
		target,
		props,
		previousLocation,
		basePathname
	});
}

export default { load };
